import { useState } from 'react';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { WarningDialog } from '@shared/components/WarningDialog/WarningDialog';
import type { ServiceAddressDisplayProps } from '@components/Checkout/steps/CustomerInfoStep/CustomerInfoStep.types';

const WARNING_DESCRIPTION =
  "Heads up! Changing your service address will clear your cart. You'll need to start your order from scratch. By clicking 'confirm', you will be taken back to the product offers page.";

export const ServiceAddressDisplay = ({ serviceAddress, onEditServiceAddress }: ServiceAddressDisplayProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleConfirmEdit = () => {
    setDialogOpen(false);
    onEditServiceAddress?.();
  };

  return (
    <>
      <Stack gap="10px">
        <Typography variant="heading.subsection" className="ServiceAddressDisplay-heading">
          Service Address
        </Typography>
        <Typography variant="body.md" className="ServiceAddressDisplay-description">
          This will be the address all your services will be registered to. We will use it for products that connect to
          your home, like Internet and TV plans.
        </Typography>
      </Stack>
      <Paper variant="serviceAddressCard" elevation={0}>
        <Typography variant="body.md" className="ServiceAddressDisplay-address">
          {serviceAddress}
        </Typography>
        <Link variant="serviceAddressEdit" underline="none" onClick={() => setDialogOpen(true)}>
          Edit
        </Link>
      </Paper>

      <WarningDialog
        open={dialogOpen}
        title="Are You Sure?"
        description={WARNING_DESCRIPTION}
        outlinedButtonText="Cancel"
        containedButtonText="Confirm"
        onOutlinedClick={() => setDialogOpen(false)}
        onContainedClick={handleConfirmEdit}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};
